import { useState, useEffect } from "react";
import styles from "./EventCard.module.scss";
import { useTranslation } from "react-i18next";
import OptionsGroup from "./OptionsGroup";
import _ from "lodash";
import { Button } from "@mui/material";
import { useSetMember } from "../misc/utils";

const EventCard = (props) => {
  const { t } = useTranslation();
  const { data, error, setValue, trigger, setPrice } = props;
  const { name, poster, id } = data || {};
  const mem = useSetMember();
  const memberType = mem.getMember();
  const location = id.slice(-3) === "TKO" ? "Tseung Kwan O" : "Tsuen Wan West";
  const [selectedOption, setSelectedOption] = useState(null);
  const [optionsList, setOptionsList] = useState([]);
  const [memberStatus, setMemberStatus] = useState("special");
  const [membershipStatus, setMembershipStatus] = useState(memberType);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    mem.setMember(membershipStatus);
    //window.location.reload();
  }, [membershipStatus]);

  const getVaiant = (boolean) => {
    return boolean ? "contained" : "outlined";
  };

  function handleClick(member) {
    if (memberType === member) {
      member = member; // Set to an empty string if the same language is clicked again
    }
    mem.setMember(member);
  }

  // Add unique Id to every options and put it into a optionList
  const initsku = () => {
    return data.sku.map((groupData) => {
      const _options = groupData.options.map((option) => {
        option.id = _.uniqueId("opt_");
        setOptionsList((prev) => {
          const _prev = [...prev];
          _prev.push(option);
          return _prev;
        });
        return { ...option, memberStatus };
      });
      groupData.options = _options;
      return groupData;
    });
  };
  const [sku, setSku] = useState(initsku);

  const optionsGroupProps = {
    optionProps: {
      setDirty,
      setValue,
      selectedOption,
      setSelectedOption,
      setPrice,
    },
  };

  useEffect(() => {
    if (dirty) trigger("option");
  }, [dirty, trigger, selectedOption]);

  return (
    <div className={`card-view ${styles.card} ${props.xc || ""}`}>
      <div className="container">
        <div className="image-div">
          <img src={poster} alt="event-detail-poster" />
        </div>
        <div className="event-info-div">
          <div className={`membership-view`}>
            <Button
              variant={memberStatus === "member" ? "contained" : "outlined"}
              disableElevation
              style={{
                backgroundColor:
                  memberStatus === "member" ? "#FFA836" : "transparent",
                color: memberStatus === "member" ? "#FFFFFF" : "#FFA836",
                borderColor: "#fa8123",
              }}
              onClick={(e) => {
                e.preventDefault();
                setMemberStatus("member");
                handleClick("member");
              }}
            >
              {t("I am Member")}
            </Button>
            <Button
              variant={memberStatus === "nonmember" ? "contained" : "outlined"}
              disableElevation
              style={{
                backgroundColor:
                  memberStatus === "nonmember" ? "#FFA836" : "transparent",
                color: memberStatus === "nonmember" ? "#FFFFFF" : "#FFA836",
                borderColor: "#fa8123",
              }}
              onClick={(e) => {
                e.preventDefault();
                setMemberStatus("nonmember");
                handleClick("nonmember");
              }}
            >
              {t("Become Member")}
            </Button>

            <div className={"input-box"}>{location}</div>
          </div>
          <h1 style={{ marginTop: 8 }}>{name}</h1>
          <h4 className={`my-2 ${error ? "error-text" : ""}`}>
            {t("Please select")}
          </h4>
          {sku.map((groupData, i) => (
            <OptionsGroup
              key={_.uniqueId("opt_gp_")}
              {...groupData}
              {...optionsGroupProps}
              optGpIndex={i}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventCard;
